/*eslint-disable*/
var navMobileToolbar = require('./nav-mobile-toolbar');

module.exports = {
  header: cube.$id('header'),
  main_content: cube.$id('main-container'),
  nav__button: cube.$('.js-navigation-button'),
  nav: cube.$id('js-navigation'),
  nav__back: cube.$id('js-navigation-back'),
  message: cube.$id('top-message-bar'),
  layout: cube.$id('js-navigation-layout'),
  footer: cube.$('.block-footer'),
  breadcrumb: cube.$('.m-breadcrumbs'),
  heightOfBanner: 0,
  fullHeaderHeight: 0,

  init: function() {
    this.updateFullHeaderHeight();
    navMobileToolbar.init();

    cube.$$('.js-navigation-button').forEach(btn => {
      btn.onclick = function() {
        cube.$('html').classList.toggle('navigation-on');
        if(btn.classList.contains('dkt-header__menu')){
          const openedNav = cube.$('html').classList.contains('navigation-on');
          btn.setAttribute('aria-expanded', openedNav);
          document.dispatchEvent(new Event(openedNav ? "anly-open-menu" : "anly-close-menu"));
        }
      };
    });

    /* Open the navigation if menuOpen boolean send true  */
    if (window.location.search === '?menuOpen=true') this.navOpening();

    cube.$$('.js-nav-search').on('click', function(e) {
      var parent = e.target.closest('.dkt-header__search');
      if (!parent.classList.contains('dkt-header__search--wide')) {
        parent.classList.add('dkt-header__search--wide');
      }
    });
    cube.$('.js-back-search').on('click', function(e) {
      var backNavSearch = e.target.closest('.dkt-header__search');
      if (backNavSearch.classList.contains('dkt-header__search--wide')) {
        backNavSearch.classList.remove('dkt-header__search--wide');
      }
    });
  },

  updateFullHeaderHeight: function() {
    var self = this;

    self.fullHeaderHeight = self.header.offsetHeight;
    if (self.message && !self.header.classList.contains('sticky')) {
      self.fullHeaderHeight += self.message.offsetHeight;
    }
  },

  /*
   * Opening of navigation.
   */
  navOpening: function() {
    var self = this;

    self.updateFullHeaderHeight();

    if (self.message) {
      var heightOfBanner;

      if (self.header.classList.contains('sticky')) {
        heightOfBanner = '0';
      } else {
        heightOfBanner = self.message.offsetHeight + 'px';
      }

      self.nav.style.top = heightOfBanner;
      self.nav.style.height = 'calc(100% - ' + heightOfBanner + ')';
      self.nav__back.style.top = heightOfBanner;
    }

    self.nav__button.className =
      'dkt-header__menu dkt-header__menu--open dkt-header__menu--active';
    self.layout.className = 'navigation__layout navigation__layout--active';
    self.main_content.className = 'navigation--opened';

    self.header.className += ' navigation--opened';
    if (self.footer) self.footer.className = 'block-footer navigation--opened';
    if (self.breadcrumb)
      self.breadcrumb.className = 'm-breadcrumbs navigation--opened';

    document.documentElement.className += ' noscroll';
    self.header.classList.remove('mobile-sticky'); // noscroll makes the scrolltop 0 on mobile, hence the remove of the mobile-sticky
  },
  /*
   * Closing of navigation.
   */
  navClosing: function() {
    var self = this;

    self.layout.className = 'navigation__layout';
    self.main_content.className = 'navigation--closed';
    self.headerHandler();
    self.nav.className = 'navigation navigation--closed';
    self.nav__button.className = 'dkt-header__menu dkt-header__menu--close';
    self.nav__back.className = 'navigation__header__back';
    if (self.footer) self.footer.className = 'block-footer navigation--closed';
    if (self.breadcrumb)
      self.breadcrumb.className = 'm-breadcrumbs navigation--closed';

    document.documentElement.classList.remove('noscroll');
  },

  /*
   * Sticky menu handler.
   */
  headerHandler: function() {
    var self = this,
      headerClass;

    if (self.header.className === 'dkt-header sticky navigation--opened') {
      headerClass = 'dkt-header sticky navigation--closed';
    } else {
      headerClass = 'dkt-header navigation--closed';
    }

    self.header.className = headerClass;

    window.setTimeout(function() {
      if (self.header.className === 'dkt-header sticky navigation--closed') {
        self.header.className = 'dkt-header sticky';
      } else {
        self.header.className = 'dkt-header';
      }
    }, 201);
  },
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/navigation-v2.js